<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  
$(document).ready(function(){
  /*
  console.log('script');
  
  if( $('body').hasClass('usato')) {
    setTimeout(changeTextButton, 200);
    
  }

  function changeTextButton() {
    $('button#product-add-to-cart').text('Richiedi Preventivo').prop('disabled', false);
    console.log('script vero');
  }

  $('button#product-add-to-cart').on('click', function(){
    alert('Prova');
  })
  */
  
});